//Reset data
export const RESET = "TICKET_SHOW_RESET"

//Loading
export const SET_TOGGLE_LOADING = "TICKET_SHOW_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "TICKET_SHOW_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "TICKET_SHOW_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "TICKET_SHOW_SET_MESSAGE"
export const SET_IS_SUCCESS = "TICKET_SHOW_SET_IS_SUCCESS"
export const SET_IS_ERROR = "TICKET_SHOW_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "TICKET_SHOW_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "TICKET_SHOW_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "TICKET_SHOW_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "TICKET_SHOW_SET_ITEMS"
export const SET_CURRENT_ITEM = "TICKET_SHOW_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "TICKET_SHOW_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "TICKET_SHOW_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "TICKET_SHOW_SET_HIDE_MODAL"


export const SET_MODAL = "TICKET_SHOW_SET_MODAL"
export const SET_MODAL_CONTENT = "TICKET_SHOW_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "TICKET_SHOW_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "TICKET_SHOW_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "TICKET_SHOW_SET_MODAL_TYPE"